.thumbnail {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 2147483647;
  width: 280px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dde1e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  font-family:
    system-ui,
    -apple-system,
    sans-serif;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  background: #f4f5f7;
  border: none;
  border-bottom: 1px solid #dde1e7;
  cursor: grab;
  text-align: left;
  touch-action: none;
  user-select: none;
}

.header:active {
  cursor: grabbing;
}

.title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1d23;
  margin-right: auto;
}

.chevron {
  font-size: 10px;
  color: #6b7280;
}

.body {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}

.group {
  border: 1px solid #dde1e7;
  border-radius: 6px;
  overflow: hidden;
}

.groupHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  background: #374151;
  color: #ffffff;
}

.groupHeaderColored {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  color: #ffffff;
}

.groupLabel {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.groupTotal {
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
}

.row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #dde1e7;
  background: #f9fafb;
}

.rowName {
  flex: 1;
  font-family: ui-monospace, 'Courier New', monospace;
  font-size: 10px;
  color: #1a1d23;
  word-break: break-all;
  min-width: 0;
}

.rowMs {
  font-size: 10px;
  font-weight: 700;
  color: #374151;
  white-space: nowrap;
  flex-shrink: 0;
}

.barTrack {
  width: 40px;
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  flex-shrink: 0;
  overflow: hidden;
}

.barFill {
  height: 100%;
  border-radius: 2px;
  background: #6b7280;
  min-width: 2px;
}

.subtotalRow {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #dde1e7;
  background: #f4f5f7;
}

.subtotalLabel {
  flex: 1;
  font-size: 10px;
  font-style: italic;
  color: #6b7280;
}

.subtotalMs {
  font-size: 10px;
  font-weight: 700;
  color: #374151;
}

.vitalRow {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #dde1e7;
  background: #f9fafb;
}

.vitalName {
  flex: 1;
  font-family: ui-monospace, 'Courier New', monospace;
  font-size: 10px;
  font-weight: 700;
  color: #1a1d23;
}

.vitalMs {
  font-size: 10px;
  font-weight: 700;
  color: #059669;
}

.vitalPending {
  font-size: 10px;
  color: #9ca3af;
  font-style: italic;
}
